import { daysBetween, formatDate, formatSigned, formatSignedPercent } from '../lib/format.ts';

/**
 * Variação com contexto: sempre diz em relação a quê e desde quando. Um "+1.183" solto não
 * informa se é por dia, por mês ou desde o início.
 */
export function DeltaBadge({
  delta,
  base,
  sinceDay,
  untilDay,
  unit = 'seguidores',
}: {
  delta: number;
  base?: number | null;
  sinceDay: string;
  untilDay?: string | null;
  unit?: string;
}) {
  const percent = base ? formatSignedPercent((delta / base) * 100) : null;
  const days = untilDay ? daysBetween(sinceDay, untilDay) : null;
  const label = `${formatSigned(delta)} ${unit}${percent ? ` (${percent})` : ''} desde ${formatDate(sinceDay)}${
    days ? `, em ${days} dias` : ''
  }`;
  return (
    <span
      className={`text-micro delta-badge-pop ${delta >= 0 ? 'text-success' : 'text-danger'}`}
      title={label}
      aria-label={label}
    >
      {formatSigned(delta)}
      {percent ? ` (${percent})` : ''} desde {formatDate(sinceDay)}
    </span>
  );
}
